<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  /** 监听页面滚动 */
  mounted() {
    window.onscroll = () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const routerName = this.$route.name;
      const bool = ['addForm','detail'].includes(routerName);
      if(bool){
        return
      }
      if (scrollTop > 0) {
        document.documentElement.style.setProperty('--background-head', '#ffffff');
        document.documentElement.style.setProperty('--page-headFontSize', '#000000');
      } else {
        document.documentElement.style.setProperty('--background-head', 'transparent');
        document.documentElement.style.setProperty('--page-headFontSize', '#ffffff');
      }
    };
  },
  methods:{
    hasForm(bool){

    }
  }
};

</script>

<style>
:root {
  --page-mainHeight: 100vh;
  --page-background: #ffffff;
  --page-headBackground: transparent;
  --page-headFontSize: #fff;
  --background-head: transparent;
}

#app {
  background: var(--page-background);
  min-height: var(--page-mainHeight);
}

@import "@/styles/common.scss";
@import "@/styles/custom_button.scss";
@import "@/assets/fonts/iconfont.css";
</style>